import { render, staticRenderFns } from "./FixBodyTypeModal.vue?vue&type=template&id=d73655ac&scoped=true"
import script from "./FixBodyTypeModal.vue?vue&type=script&lang=js"
export * from "./FixBodyTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73655ac",
  null
  
)

export default component.exports